import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Member } from '../models/member';

type MemberEditFamilyMessageProps = {
  member: Member;
};

export const MemberEditFamilyMessage = (props: MemberEditFamilyMessageProps) => {
  const { member } = props;
  const { t } = useTranslation(['member']);
  if (member && member.familyMembers && member.familyMembers.length > 0) {
    return (
      <Alert severity='warning' variant='filled' sx={{ borderRadius: 0 }}>
        <AlertTitle sx={{ fontSize: '1.2rem' }}>{t('editMember.familyWarningMessage')}</AlertTitle>
        {t('editMember.familyWarningDescription')}
      </Alert>
    );
  }
  return null;
};
